import { render, staticRenderFns } from "./tabLeadActions.vue?vue&type=template&id=c14b3e12&"
import script from "./tabLeadActions.vue?vue&type=script&lang=js&"
export * from "./tabLeadActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports